

export default function Contact() {
	return(
		<div>
		</div>
	);
}